var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v("客户第一 真诚 激情 创新 执行")]),_c('p',[_vm._v("Customer first sincere passion innovation implementation")])])])])
}]

export { render, staticRenderFns }